export default __webpack_public_path__ + "static/media/feedback-back.234c7d23.png";